import { $t, CANONICAL_COUNTRY_CODE } from "@/utils";
import { FROM_NAME, FROM_TYPE } from "@/utils/const";

// 来源 source // 1:擎天柱，2:app闭环，3:二线客服，4:补偿工具，5:一线客服，6麦哲伦，7:擎天柱3.0，8:外部
// 入口  工单页工具-补偿工具 ： 5 ，补偿列表新增 ：4
export const SOURCE = {
    COMPEN: 5,
}

export const TOOL_COMPEN = {
    CHANNELREFUND_VAL: 4, // 原渠道退款 val 值
    COUPON_VAL: 2,// 代金券 val 值
    PAY_VAL: 17,// 乘客钱包补偿 val 值
    BALANCE_VAL: 1,// 司机余额补偿 val 值
    
    DEDUCT_DRIVER_VAL: 5,// 司机原渠道扣款 val 值
    DALANCE_DRIVER_VAL: 3,// 司机余额扣款 val 值

    RIDER_CUSTOMER_TYPE: 1,// 乘客类型
    DRIVER_CUSTOMER_TYPE: 2,// 司机类型RIDER_COMPEN_INDEX = 0 // 乘客补偿索引值

    TABDEFAULTACTIVEKEY: "0",  // 页卡默认展示
    RIDER_COMPEN_INDEX: "0", // 乘客补偿索引值
    DRIVER_COMPEN_INDEX: "1",// 司机补偿索引值
    DRIVER_DEDUCT_INDEX: "2",// 司机扣款索引值
    RIDER_COMPEN_KEY: "riderCompen", // 乘客补偿
    DRIVER_COMPEN_KEY: "driverCompen", // 司机补偿
    DRIVER_DEDUCT_KEY: "driverDeduct",// 司机扣款
}

const {
    CHANNELREFUND_VAL,
    COUPON_VAL,
    PAY_VAL,
    BALANCE_VAL,
    DEDUCT_DRIVER_VAL,
    DALANCE_DRIVER_VAL,
    RIDER_CUSTOMER_TYPE,
    DRIVER_CUSTOMER_TYPE,
    RIDER_COMPEN_INDEX,
    DRIVER_COMPEN_INDEX,
    DRIVER_DEDUCT_INDEX,
    RIDER_COMPEN_KEY,
    DRIVER_COMPEN_KEY,
    DRIVER_DEDUCT_KEY,
} = TOOL_COMPEN

// 乘客补偿 - 补偿途径列表
let RC_CUSTOMER_TYPE = [{
    'label': $t('comTool.channelRefund'),
    'value': CHANNELREFUND_VAL
}, {
    'label': $t('comTool.coupon'),
    'value': COUPON_VAL
}]

// 巴西添加99pay
if (CANONICAL_COUNTRY_CODE === 'BR') {
    RC_CUSTOMER_TYPE.unshift({
        'label': $t('comTool.pay'),
        'value': PAY_VAL
    })
}

// 司机补偿 - 补偿途径
export const DC_CUSTOMER_TYPE = [{
    'label': $t('comTool.balance'),
    'value': BALANCE_VAL
}]

// 司机扣款 - 扣款途径
const DD_CUSTOMER_TYPE = [
//     {
//     'label': 'original channel deduct driver',
//     'value': DEDUCT_DRIVER_VAL
// },
{
    'label': $t('CS_2_Driver_balance_otCh'), // CS_2_Driver_balance_otCh
    'value': DALANCE_DRIVER_VAL
}]

// 乘客补偿 展示表单列表
const RIDER_FROM_LIST = {
    [CHANNELREFUND_VAL]: [ // 4 channelRefund
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.CONTENT,
    ],
    [COUPON_VAL]: [ // 2 coupon
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.PHONE,
        FROM_NAME.COUPONBUSINESSTYPE,
        FROM_NAME.PRICE,
        FROM_NAME.CONTENT,
    ],
    [PAY_VAL]: [ // 5 pay
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.PHONE,
        FROM_NAME.AMOUNT,
        FROM_NAME.CONTENT,
    ]
}

// 司机补偿 展示表单列表
const DRIVER_COMPEN_FROM_LIST = {
    [BALANCE_VAL]: [ // 1 余额
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.PHONE,
        FROM_NAME.AMOUNT,
        // FROM_NAME.TAGS,
        FROM_NAME.CONTENT,
    ]
}

// 司机扣款 展示表单列表
const DRIVER_DEDUCT_FROM_LIST = {
    [DALANCE_DRIVER_VAL]: [ // 3 司机余额扣款 val 值
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.PHONE,
        FROM_NAME.AMOUNT,
        FROM_NAME.CONTENT,
    ],
    [DEDUCT_DRIVER_VAL]: [ // 5 扣款途径
        FROM_NAME.TICKETID,
        FROM_NAME.ORDERID,
        FROM_NAME.OPERATETYPE,
        FROM_NAME.REASON,
        FROM_NAME.CONTENT,
    ]
}

// 补偿列表item
export const formItemConfig = {
    [FROM_NAME.TICKETID]: { // 工单ID
        label: $t('list.worksheetId'),
        name: FROM_NAME.TICKETID,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.INPUT
    },
    [FROM_NAME.ORDERID]: { // 订单ID
        label: $t('list.orderId'),
        name: FROM_NAME.ORDERID,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.INPUT
    },
    [FROM_NAME.OPERATETYPE]: { // 补偿途径
        label: $t('comTool.routeOfCompensation'),
        name: FROM_NAME.OPERATETYPE,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.SELECT,
        option: [],
        fieldNames: {
            ovalue: 'value',
            oname: 'value',
            okey: 'value',
            olabel: 'label',
        }
    },
    [FROM_NAME.REASON]: { // 补偿原因
        label: $t('comTool.reasonForCompensation'),
        name: FROM_NAME.REASON,
        rules: [
            {
                required: true,
                message: $t('CS_Settings_Can_not_wuTx'),
            }
        ],
        required: true,
        itemType: FROM_TYPE.SELECT,
        option: [],
        fieldNames: {
            ovalue: 'id',
            oname: 'id',
            okey: 'id',
            olabel: 'itemValue',
        }
    },
    [FROM_NAME.COUPONBUSINESSTYPE]: { // 业务类型
        label: $t('work.businessTypeName'),
        name: FROM_NAME.COUPONBUSINESSTYPE,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.SELECT,
        option: [],
        fieldNames: {
            ovalue: 'id',
            oname: 'id',
            okey: 'id',
            olabel: 'title',
        }
    },
    [FROM_NAME.PHONE]: { // 用户手机
        label: $t('list.compensatePhone'), 
        name: FROM_NAME.PHONE,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.COMPON,
        fieldNames: {
            ovalue: 'phone',
            oname: 'phone',
            okey: 'phone',
            olabel: 'phone',
        }
    },
    [FROM_NAME.PRICE]: { // 余额
        label: $t('comTool.balance'),
        name: FROM_NAME.PRICE,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.SELECT,
        fieldNames: {
            ovalue: 'price',
            oname: 'price',
            okey: 'price',
            olabel: 'price',
        }
    },
    [FROM_NAME.AMOUNT]: { // 金额
        label: $t('list.amount'),
        name: FROM_NAME.AMOUNT,
        rules: [{
            required: true,
            message: $t('CS_Settings_Can_not_wuTx'),
        }],
        required: true,
        itemType: FROM_TYPE.INPUT
    },
    [FROM_NAME.CONTENT]: {// 补偿内容详情
        label: $t('comTool.detailsOfCompensation'),
        name: FROM_NAME.CONTENT,
        rules: [],
        required: false,
        itemType: FROM_TYPE.TEXTAREA
    },
    [FROM_NAME.TAGS]: { // 标签
        label: $t('new.tags'),
        name: FROM_NAME.TAGS,
        rules: [],
        required: true,
        itemType: FROM_TYPE.INPUT
    },
}

// from表单默认值
// const RIDER_FROM_VALUES = {
//     "ticketid": "",
//     "content": "",
//     "orderId": "",
//     "reason": "",
//     "operateType": CHANNELREFUND_VAL,
// }

const DRIVER_COMPEN_FROM_VALUES = {
    "ticketid": "",
    "orderId": "",
    "content": "",
    "reason": "",
    "operateType": BALANCE_VAL,
}

const DRIVER_DEDUCT_FROM_VALUES = {
    "ticketid": "",
    "orderId": "",
    "content": "",
    "reason": "",
    "operateType": DALANCE_DRIVER_VAL,
}

// 配置信息设置
export const COMPENSATECONFIG = {
    compenTabs: [RIDER_COMPEN_KEY, DRIVER_COMPEN_KEY, DRIVER_DEDUCT_KEY], // 页卡名称
    riderCompen: {
        label: $t('comTool.riderCompensation'),
        index: RIDER_COMPEN_INDEX,
        compensateCustomerType: RIDER_CUSTOMER_TYPE, // 用户身份 
        customerType: RC_CUSTOMER_TYPE, // 补偿途径列表
        fromList: RIDER_FROM_LIST, // 补偿列表
        initialFromValues: null, // form 表单默认值
        operateType : CHANNELREFUND_VAL // 补偿类型 key 值
    },
    driverCompen: {
        label: $t('comTool.driverCompensation'),
        index: DRIVER_COMPEN_INDEX,
        compensateCustomerType: DRIVER_CUSTOMER_TYPE,
        customerType: DC_CUSTOMER_TYPE,
        fromList: DRIVER_COMPEN_FROM_LIST,
        initialFromValues: DRIVER_COMPEN_FROM_VALUES,
        operateType : BALANCE_VAL // 补偿类型 key 值
    },
    driverDeduct: {
        label: $t('comTool.driverDeduction'), 
        index: DRIVER_DEDUCT_INDEX,
        compensateCustomerType: DRIVER_CUSTOMER_TYPE,
        customerType: DD_CUSTOMER_TYPE,
        fromList: DRIVER_DEDUCT_FROM_LIST,
        initialFromValues: DRIVER_DEDUCT_FROM_VALUES,
        operateType : DALANCE_DRIVER_VAL // 补偿类型 key 值
    }
}
